import { Cart, CartItem } from '@/types/data-types'

export type CartState = Cart

export interface UseCartHookResp {
  loaded: boolean
  state: CartState
  addItem: (item: CartItem) => Promise<void>
  updateItem: (productId: number, quantity: number) => Promise<void>
  removeItem: (productId: number) => Promise<void>
  clearCart: () => Promise<void>
}

export type UseLocalCartHookResp = UseCartHookResp

export interface UseRemoteCartHookResp extends UseCartHookResp {
  mergeCart: (
    localCartItems: Array<{
      productId: number
      quantity: number
    }>
  ) => Promise<void>
}

export enum CartActions {
  FETCH_CART,
  ADD_ITEM,
  REMOVE_ITEM,
  UPDATE_ITEM,
  CLEAR_CART,
  MERGE_CART
}
